import React from 'react'
import './Loader.css'
export default function Loader() {
  return (
    <div>
        
        <div class="loader-container">
        <div class="loader"></div>
        </div>

    </div>
  )
}
